// Shared value-shapes for the reusable Phase 0 building blocks. These are the
// controlled value/onChange contracts later feature phases (quotes #27/#29/#30,
// invoices #40/#42/#43, contracts #57, attachments #13/#31/#32/#44/#59/#70/#75)
// wire into their forms. Kept framework-free so they can travel into
// react-hook-form fields or plain useState.

// --- Optional charges / surcharges (#29, #42) ---
// Backend surcharge taxonomy. `custom` requires a description.
export type OptionalChargeType =
  | 'emergency'
  | 'after_hours'
  | 'weekend'
  | 'holiday'
  | 'distance'
  | 'custom'

export const OPTIONAL_CHARGE_TYPES: OptionalChargeType[] = [
  'emergency',
  'after_hours',
  'weekend',
  'holiday',
  'distance',
  'custom',
]

export interface OptionalCharge {
  id?: string
  type: OptionalChargeType
  // Required only when `type === 'custom'`; optional/free-text otherwise.
  description?: string
  image_file_id?: string | null
  image_url?: string | null
  amount: number
  tax_rate?: number
}

// --- Attachments (#13, #31, #32, #44, #59, #70, #75) ---
// A normalised attachment reference, whatever its origin (freshly uploaded,
// picked from the client's documents, or from the Settings document library).
export interface AttachmentRef {
  // Stable id once persisted/uploaded; may be absent for a pending local pick.
  id?: string
  // Underlying file id, shared by the owner's attachment and picker sources.
  file_id?: string
  name: string
  url?: string | null
  // MIME type and byte size when known (drives the file-row metadata line).
  mime_type?: string | null
  size?: number | null
  // Upload / create timestamp when known (file-card date line).
  created_at?: string | null
  // Preserve a linked document's job-specific classification when it is
  // carried into another create form (for example, job duplication).
  doc_type?: string | null
  // Where this attachment came from, so callers can group/de-dupe if needed.
  source: 'upload' | 'client' | 'library'
  // The raw file for an upload-new pick that hasn't been persisted yet (create
  // mode, before the owning entity exists). Carried so it can be uploaded once
  // the entity is created. Absent for already-persisted or picked refs.
  file?: File
}
